import { rem } from 'polished';
import { css, breakpoints } from '../../../styles/theme';

export const StylesAC = css`
    li {
        color: ${({ theme }) => theme.colors.orange1};

        a:hover {
            color: ${({ theme }) => theme.colors.brown5};
        }

        &.active {
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .my-account-content-title {
        text-transform: uppercase;
        font-family: ${({ theme }) => theme.fonts.fontBase};
    }

    .my-account-page .my-account-content {
        padding-top: ${rem(5)};
        max-width: 100%;

        .my-account-breadcrumbs {
            span,
            a {
                color: ${({ theme }) => theme.colors.grey5};
            }
            a:hover {
                color: ${({ theme }) => theme.colors.red};
            }
        }
    }

    .my-account-page .my-account-content .my-account-home {
        margin-bottom: ${rem('70px')};
        padding-top: 0;

        @media (min-width: ${rem(952)}) {
            flex-direction: row;
        }
    }

    .my-account-page .my-account-content-title {
        margin-left: 0;
        font-weight: 900;
        font-size: ${rem('40px')};
        margin-bottom: 34px;
        color: ${({ theme }) => theme.colors.grey5};
    }

    .my-account-page .my-account-content .my-account-home .imgbtn:nth-of-type(even) {
        @media (min-width: ${rem(952)}) {
            margin-left: ${rem(20)};
        }
    }

    .my-account-home .imgbtn {
        margin-bottom: ${rem(10)};

        @media (min-width: ${breakpoints.sm}px) {
            margin-right: ${rem(10)};
        }
    }

    .my-account-page {
        padding: 0 ${rem(15)};
    }

    .deal .deal-content .car-header .price-and-date .price-container .currencyLabel {
        padding-left: 0 !important;
    }

    .date-clock-icon .icon-wrapper {
        margin-right: ${rem(5)} !important;
    }

    .my-account-controller {
        display: flex;
    }
`;
